import actions from './actions';

const initState = {
	dataWriteFromDictation: [],
	writeFromDictationDetail: null,
	totalItems: 0,
	loading: false,
};

export default function writeFromDictationReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_WRITE_FROM_DICTATION:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_WRITE_FROM_DICTATION_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataWriteFromDictation: res, totalItems, loading: false };

		case actions.GET_WRITE_FROM_DICTATION_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_WRITE_FROM_DICTATION_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, writeFromDictationDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
